export default "__VITE_ASSET__Cma4JdYg__"